import React from "react";

export default function Select({
  placeholder,
  options,
  iconLeft,
  iconRight,
  required,
  className,
}) {
  return (
    <div className={`relative ${className}`}>
      {iconLeft && (
        <div className="max-w-[30px] w-full absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
          <img src={iconLeft} alt="Left Icon" />
        </div>
      )}
      <select
        className={`appearance-none focus:outline-none w-full py-[10px] px-[15px] bg-transparent border-[1px] border-[#fff] text-[#fff] 
          ${iconLeft ? "pl-[40px]" : "pl-[15px]"} 
          ${iconRight ? "pr-[40px]" : "pr-[15px]"} 
          Typography.Smp`}
        required={required}
        defaultValue=""
      >
        <option value="" disabled hidden>
          {placeholder || "Select an option"}
        </option>
        {options.map((option, index) => (
          <option
            key={index}
            value={option.value}
            className="bg-black text-white"
          >
            {option.label}
          </option>
        ))}
      </select>
      {iconRight && (
        <div className="max-w-[30px] w-full absolute inset-y-0 end-0 flex items-center pr-3 pointer-events-none">
          <img src={iconRight} alt="Right Icon" />
        </div>
      )}
    </div>
  );
}
